module.exports = __webpack_public_path__ + "img/图片4.5ee481b1.png";